// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6420":"7b12da16d2af4a44","7205":"605ccf07e92caf72"}[chunkId] + ".js";
};